var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.749,
    height: 14.522,
    viewBox: "0 0 17.749 14.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "note",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M19.942,21v7.261a.809.809,0,0,1-.807.807H3.807A.809.809,0,0,1,3,28.261V21",
    transform: "translate(-0.597 -8.949)",
    fill: "#58bf97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M8.647,15.874H3.807A.809.809,0,0,1,3,15.068V7.807A.809.809,0,0,1,3.807,7H19.135a.809.809,0,0,1,.807.807v7.261a.809.809,0,0,1-.807.807H14.295",
    transform: "translate(-0.597 -0.597)",
    fill: "#58bf97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M18.539,28.874H3.21A1.189,1.189,0,0,1,2,27.664V20.4a.381.381,0,0,1,.4-.4.381.381,0,0,1,.4.4v7.261a.381.381,0,0,0,.4.4H18.539a.381.381,0,0,0,.4-.4V20.4a.4.4,0,0,1,.807,0v7.261A1.189,1.189,0,0,1,18.539,28.874Z",
    transform: "translate(0 -8.353)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M16.681,16.647H19.5a1.189,1.189,0,0,1,1.21-1.21V12.21A1.189,1.189,0,0,1,19.5,11H16.681m-5.647,0H8.21A1.189,1.189,0,0,1,7,12.21v3.227a1.189,1.189,0,0,1,1.21,1.21h2.824",
    transform: "translate(-2.983 -2.983)",
    fill: "#38a378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M17,20.715V7h5.647V20.715",
    transform: "translate(-8.949 -0.597)",
    fill: "#e7f0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M18.539,6H3.21A1.189,1.189,0,0,0,2,7.21v12.1a1.189,1.189,0,0,0,1.21,1.21H18.539a1.189,1.189,0,0,0,1.21-1.21V7.21A1.189,1.189,0,0,0,18.539,6Zm0,.807a.381.381,0,0,1,.4.4v7.261a.381.381,0,0,1-.4.4H14.1v-.807h2.42a.414.414,0,0,0,.4-.4.809.809,0,0,1,.807-.807.381.381,0,0,0,.4-.4V9.227a.414.414,0,0,0-.4-.4.809.809,0,0,1-.807-.807.381.381,0,0,0-.4-.4H14.1V6.807ZM14.1,8.42h2.057a1.706,1.706,0,0,0,1.17,1.17v2.5a1.706,1.706,0,0,0-1.17,1.17H14.1ZM7.647,13.261H5.59a1.706,1.706,0,0,0-1.17-1.17V9.59A1.706,1.706,0,0,0,5.59,8.42H7.647ZM2.807,7.21a.381.381,0,0,1,.4-.4H7.647v.807H5.227a.414.414,0,0,0-.4.4.809.809,0,0,1-.807.807.381.381,0,0,0-.4.4v3.227a.414.414,0,0,0,.4.4.809.809,0,0,1,.807.807.381.381,0,0,0,.4.4h2.42v.807H3.21a.381.381,0,0,1-.4-.4V7.21Zm4.841,12.5H3.21a.381.381,0,0,1-.4-.4v-.484a1.193,1.193,0,0,0,.4.081H7.647Zm0-1.614H3.21a.381.381,0,0,1-.4-.4v-.484a1.193,1.193,0,0,0,.4.081H7.647ZM3.21,16.488a.381.381,0,0,1-.4-.4V15.6a1.193,1.193,0,0,0,.4.081H7.647v.807Zm10.085,3.227H8.454V8.017h0V6.807h4.841Zm5.647-.4a.381.381,0,0,1-.4.4H14.1v-.807h4.437a1.193,1.193,0,0,0,.4-.081Zm0-1.614a.381.381,0,0,1-.4.4H14.1v-.807h4.437a1.193,1.193,0,0,0,.4-.081Zm-.4-1.21H14.1v-.807h4.437a1.193,1.193,0,0,0,.4-.081v.484A.381.381,0,0,1,18.539,16.488Z",
    transform: "translate(0 0)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 0.908,
    cy: 0.605,
    rx: 0.908,
    ry: 0.605,
    transform: "translate(5.025 10.235)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.605,
    cy: 0.605,
    r: 0.605,
    transform: "translate(15.31 10.235)",
    fill: "#010101"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.5fe34a346fc4d5c470a88391812d3f8e.svg";
export { ForwardRef as ReactComponent };